<template>
  <div class="px-10 py-6 white">
    <v-row>
      <v-col xs="12" sm="12" md="12" lg="3">
        <v-select
          :items="calendarList"
          item-text="label"
          item-value="key"
          v-model="selectedCalendar"
          color="secondary"
          dense
          filled
        />
      </v-col>
      <v-col class="pa-7" xs="12" :lg="$site === $const.sites.galileo ? '6' : '9'">
        <CalendarGuide :steps="currentCalendarSteps" />
      </v-col>
      <v-col class="d-xs-none" lg="3">
        <img :src="require(`@/assets/onboarding-calendar-${$site}.png`)" alt="" />
      </v-col>
    </v-row>

  </div>
</template>

<script>
import CalendarGuide from '@/components/calendar/calendarGuides/CalendarGuide'
export default {
  name: 'CalendarSettings',
  components: {
    CalendarGuide
  },
  data() {
    return {
      calendarGuidesSteps: {
        googleCalendar: {
          step1: {
            title: this.$t('calendarSettings.steps.copyLink'),
            link: this.$store.getters.currentShop.iCalLink
          },
          step2: {
            title: this.$t('calendarSettings.steps.googleCalendar.step2'),
            image: require(`@/assets/calendarGuides/google_1.jpg`)
          },
          step3: {
            title: this.$t('calendarSettings.steps.googleCalendar.step3'),
            image: require(`@/assets/calendarGuides/google_2.jpg`)
          },
          step4: {
            title: this.$t('calendarSettings.steps.googleCalendar.step4'),
            image: require(`@/assets/calendarGuides/google_3.jpg`)
          }
        },
        iCal: {
          step1: {
            title: this.$t('calendarSettings.steps.copyLink'),
            link: this.$store.getters.currentShop.iCalLink
          },
          step2: {
            title: this.$t('calendarSettings.steps.iCal.step2'),
            image: require(`@/assets/calendarGuides/ical_1.png`)
          },
          step3: {
            title: this.$t('calendarSettings.steps.iCal.step3'),
            image: require(`@/assets/calendarGuides/ical_2.png`)
          },
          step4: {
            title: this.$t('calendarSettings.steps.iCal.step4'),
            image: require(`@/assets/calendarGuides/ical_3.png`)
          }
        },
        outlook: {
          step1: {
            title: this.$t('calendarSettings.steps.copyLink'),
            link: this.$store.getters.currentShop.iCalLink
          },
          step2: {
            title: this.$t('calendarSettings.steps.outlook.step2'),
            image: require(`@/assets/calendarGuides/outlook_1.png`)
          },
          step3: {
            title: this.$t('calendarSettings.steps.outlook.step3'),
            image: require(`@/assets/calendarGuides/outlook_2.png`)
          },
          step4: {
            title: this.$t('calendarSettings.steps.outlook.step4'),
            image: require(`@/assets/calendarGuides/outlook_3.png`)
          }
        },
        office: {
          step1: {
            title: this.$t('calendarSettings.steps.copyLink'),
            link: this.$store.getters.currentShop.iCalLink
          },
          step2: {
            title: this.$t('calendarSettings.steps.office.step2'),
            image: require(`@/assets/calendarGuides/office_1.gif`)
          },
          step3: {
            title: this.$t('calendarSettings.steps.office.step3'),
            image: require(`@/assets/calendarGuides/office_2.gif`)
          },
          step4: {
            title: this.$t('calendarSettings.steps.office.step4'),
            image: require(`@/assets/calendarGuides/office_3.gif`)
          }
        },
        yahoo: {
          step1: {
            title: this.$t('calendarSettings.steps.copyLink'),
            link: this.$store.getters.currentShop.iCalLink
          },
          step2: {
            title: this.$t('calendarSettings.steps.yahoo.step2'),
            image: require(`@/assets/calendarGuides/yahoo_1.png`)
          },
          step3: {
            title: this.$t('calendarSettings.steps.yahoo.step3'),
            image: require(`@/assets/calendarGuides/yahoo_2.png`)
          },
          step4: {
            title: this.$t('calendarSettings.steps.yahoo.step4'),
            image: require(`@/assets/calendarGuides/yahoo_3.png`)
          }
        }
      },
      calendarList: [
        {
          key: 'googleCalendar',
          label: this.$t('calendarSettings.calendars.googleCalendar')
        },
        {
          key: 'iCal',
          label: this.$t('calendarSettings.calendars.iCal')
        },
        {
          key: 'office',
          label: this.$t('calendarSettings.calendars.office')
        },
        {
          key: 'outlook',
          label: this.$t('calendarSettings.calendars.outlook')
        },
        {
          key: 'yahoo',
          label: this.$t('calendarSettings.calendars.yahoo')
        }
      ],
      selectedCalendar: 'googleCalendar'
    }
  },
  computed: {
    currentCalendarSteps() {
      return this.calendarGuidesSteps[this.selectedCalendar]
    }
  }
}
</script>
